


















import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('RiskProfile', {
      newRiskProfile: 'newRiskProfile',
    }),
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
  },
})
export default class RiskProfileCreateBasicInfo extends Vue {
  @Prop() readonly title!: string;
  @Prop() readonly description!: string;
  @PropSync('valid') isValid!: boolean;

  newRiskProfile!: NewRiskProfile;
  business!: Model;

  // Computed
  get riskProfileVal() {
    return this.newRiskProfile;
  }
  set riskProfileVal(v) {
    this.$store.commit('RiskProfile/SET_NEW_RISK_PROFILE', v);
  }
}
